// FCVD Personalisatie — inline op de productpagina.
//  - "Preview bedrukking"-paneel over de galerij (voor/achter-weergaven);
//  - 3 losse opties met prijs; totaalprijs; spelerskiezer;
//  - bij add-to-cart worden gekozen opties als add-on-regels toegevoegd met gedeeld _bundle_id
//    (zelfde mechanisme als fcvd-addons) → checkout/factuur/pakbon rekenen alles.
(function () {
  'use strict';

  var root = document.querySelector('[data-fcvd-pers]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-fcvd-config]').textContent) || {}; } catch (e) { return; }

  var MODE = (cfg.modus === 'vast') ? 'vast' : 'live';
  var BASE_W = 500;
  var naamCfg = cfg.naam || {};
  var nrCfg = cfg.nummer || {};
  // Onveranderlijke basis; per optiewaarde (cfg.varianten) wordt hier overheen gelegd
  var baseNaam = JSON.parse(JSON.stringify(naamCfg));
  var baseNr = JSON.parse(JSON.stringify(nrCfg));

  var form = document.getElementById('product-form');
  var toggle = root.querySelector('[data-fcvd-toggle]');
  var panel = root.querySelector('[data-fcvd-panel]');
  var totaalEl = root.querySelector('[data-fcvd-totaal]');
  var totalValEl = root.querySelector('[data-fcvd-total-value]');
  var showBtn = root.querySelector('[data-fcvd-show]');
  var mobBtn = root.querySelector('[data-fcvd-mobpreview]');
  var playerSel = root.querySelector('[data-fcvd-player]');
  var keuzeWrap = root.querySelector('[data-fcvd-keuze]');
  var spelerWrap = root.querySelector('[data-fcvd-spelerwrap]');
  var optionChecks = Array.prototype.slice.call(root.querySelectorAll('[data-fcvd-optie]'));
  var inpName = root.querySelector('[data-fcvd-name]');
  var inpNumber = root.querySelector('[data-fcvd-number]');
  var basePrice = parseInt(root.getAttribute('data-fcvd-baseprice'), 10) || 0; // cents

  var gallery = document.querySelector('[data-gallery]');
  var baseUrl = root.getAttribute('data-fcvd-base') || '';
  var voorkantUrl = root.getAttribute('data-fcvd-voorkant') || '';
  var impressieUrl = root.getAttribute('data-fcvd-impressie') || '';

  function money(cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function inputFor(check) { return check.closest('.fcvd-optie').querySelector('.fcvd-optie__input'); }

  // ---------- Preview (voor/achter) ----------
  var views;
  if (MODE === 'vast') views = [{ key: 'vast', url: impressieUrl || baseUrl, shows: [], label: '' }];
  else if (voorkantUrl) views = [
    { key: 'voor', url: voorkantUrl, shows: ['naam'], label: 'Voorkant' },
    { key: 'achter', url: baseUrl, shows: ['nummer'], label: 'Achterkant' }
  ];
  else views = [{ key: 'main', url: baseUrl, shows: ['naam', 'nummer'], label: '' }];
  var curView = views.length > 1 ? 1 : 0;

  var preview = null, pImg, pName, pNum, pStage, pSwitch;

  function buildPreview() {
    if (preview || !gallery) return;
    preview = document.createElement('div');
    preview.className = 'fcvd-preview';
    preview.hidden = true;
    var sw = '';
    if (views.length > 1) sw = '<div class="fcvd-preview__switch">' + views.map(function (v, i) {
      return '<button type="button" class="fcvd-preview__view' + (i === curView ? ' is-active' : '') + '" data-view="' + i + '">' + v.label + '</button>';
    }).join('') + '</div>';
    preview.innerHTML =
      '<div class="fcvd-preview__label">Preview bedrukking</div>' +
      '<button type="button" class="fcvd-preview__close" aria-label="Sluiten">' +
      '<svg viewBox="0 0 24 24" width="36" height="36"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round"/></svg></button>' +
      '<div class="fcvd-preview__stage"><img class="fcvd-preview__img" alt="Preview bedrukking">' +
      '<span class="fcvd-ov__name"></span><span class="fcvd-ov__number"></span></div>' + sw;
    gallery.appendChild(preview);
    pStage = preview.querySelector('.fcvd-preview__stage');
    pImg = preview.querySelector('.fcvd-preview__img');
    pName = preview.querySelector('.fcvd-ov__name');
    pNum = preview.querySelector('.fcvd-ov__number');
    pSwitch = preview.querySelector('.fcvd-preview__switch');
    styleOverlay();
    pImg.addEventListener('load', fitStage);
    preview.querySelector('.fcvd-preview__close').addEventListener('click', function () {
      preview.hidden = true;
      if (showBtn && toggle && toggle.checked) showBtn.hidden = false;
    });
    if (pSwitch) pSwitch.addEventListener('click', function (e) {
      var b = e.target.closest('[data-view]'); if (b) showView(parseInt(b.getAttribute('data-view'), 10));
    });
  }
  function styleOverlay() {
    if (!pName || !pNum) return;
    pName.style.top = naamCfg.top != null ? naamCfg.top + '%' : '';
    pName.style.left = (naamCfg.left != null ? naamCfg.left : 50) + '%';
    if (naamCfg.kleur) pName.style.color = naamCfg.kleur;
    pName.style.transform = 'translateX(-50%)' + (naamCfg.rotatie ? ' rotate(' + naamCfg.rotatie + 'deg)' : '');
    pNum.style.top = nrCfg.top != null ? nrCfg.top + '%' : '';
    pNum.style.left = (nrCfg.left != null ? nrCfg.left : 50) + '%';
    if (nrCfg.kleur) pNum.style.color = nrCfg.kleur;
    pNum.style.transform = 'translateX(-50%)' + (nrCfg.rotatie ? ' rotate(' + nrCfg.rotatie + 'deg)' : '');
  }
  function showView(i) {
    curView = i;
    if (pSwitch) Array.prototype.forEach.call(pSwitch.children, function (b, idx) { b.classList.toggle('is-active', idx === i); });
    var url = views[i].url;
    if (url && pImg.getAttribute('src') !== url) pImg.src = url; else fitStage();
  }
  function values() {
    return {
      naam: (inpName && !inpName.disabled) ? inpName.value.trim() : '',
      nummer: (inpNumber && !inpNumber.disabled) ? inpNumber.value.trim() : ''
    };
  }
  function updatePreview() {
    if (!preview || preview.hidden || !pStage) return;
    var scale = (pStage.getBoundingClientRect().width || BASE_W) / BASE_W;
    var v = values(), shows = views[curView].shows;
    var showName = MODE === 'live' && shows.indexOf('naam') > -1 && naamCfg.overlay !== false;
    var showNum = MODE === 'live' && shows.indexOf('nummer') > -1 && nrCfg.overlay !== false;
    pName.textContent = (showName && v.naam) ? v.naam.toUpperCase() : '';
    pName.style.fontSize = (parseFloat(naamCfg.font || 1.5) * scale) + 'rem';
    pNum.textContent = (showNum && v.nummer) ? v.nummer : '';
    pNum.style.fontSize = (parseFloat(nrCfg.font || 6) * scale) + 'rem';
  }
  function fitStage() {
    if (!preview || preview.hidden || !pImg || !pImg.naturalWidth) return;
    var ar = pImg.naturalWidth / pImg.naturalHeight, cs = getComputedStyle(preview);
    var availW = preview.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var availH = preview.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var h = availH, w = h * ar;
    if (w > availW) { w = availW; h = w / ar; }
    pStage.style.width = w + 'px'; pStage.style.height = h + 'px';
    updatePreview();
  }
  function openPreview() {
    buildPreview(); if (!preview) return;
    var url = views[curView].url;
    if (url && pImg.getAttribute('src') !== url) pImg.src = url;
    preview.hidden = false; if (showBtn) showBtn.hidden = true;
    fitStage();
  }

  // ---------- Per optiewaarde (bijv. kleur) afwijkende letterkleur / afbeeldingen ----------
  // cfg.varianten = { optie: "Kleur", waarden: { "Geel": { kleur, naam_kleur, nummer_kleur,
  //                   voorkant_afbeelding, basis_afbeelding, impressie_afbeelding,
  //                   naam: {top,left,rotatie,font}, nummer: {top,left,rotatie,font} }, ... } }
  //   naam/nummer overschrijven per waarde de basis (cfg.naam / cfg.nummer), zonder door te lekken.
  var varCfg = (cfg.varianten && cfg.varianten.waarden) ? cfg.varianten : null;
  function handleOf(s) { return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function selectedValue() {
    var names = window.fcvdOptionNames || [], v = window.fcvdSelectedVariant, want = String(varCfg.optie || '').toLowerCase();
    for (var i = 0; i < names.length; i++) {
      if (String(names[i]).toLowerCase() === want && v && v.options) return v.options[i];
    }
    var r = document.querySelector('input[name="attribute_' + handleOf(varCfg.optie || '') + '"]:checked');
    return r ? r.value : null;
  }
  function applyVariant() {
    if (!varCfg) return;
    var ov = varCfg.waarden[selectedValue()];
    if (!ov) return;
    views.forEach(function (vw) {
      if (vw.key === 'voor' && ov.voorkant_afbeelding) vw.url = ov.voorkant_afbeelding;
      if ((vw.key === 'achter' || vw.key === 'main') && ov.basis_afbeelding) vw.url = ov.basis_afbeelding;
      if (vw.key === 'vast' && ov.impressie_afbeelding) vw.url = ov.impressie_afbeelding;
    });
    naamCfg = Object.assign({}, baseNaam, ov.naam || {});
    nrCfg = Object.assign({}, baseNr, ov.nummer || {});
    var kn = ov.naam_kleur || ov.kleur, kr = ov.nummer_kleur || ov.kleur;
    if (kn) naamCfg.kleur = kn;
    if (kr) nrCfg.kleur = kr;
    styleOverlay();
    if (preview && !preview.hidden) {
      var url = views[curView].url;
      if (url && pImg.getAttribute('src') !== url) pImg.src = url; else fitStage();
    }
  }
  applyVariant();
  document.addEventListener('fcvd:variantchange', applyVariant);

  // ---------- Opties / totaal ----------
  function updateTotal() {
    if (!totalValEl) return;
    var sum = basePrice;
    optionChecks.forEach(function (c) {
      if (c.checked) sum += Math.round(parseFloat(c.getAttribute('data-prijs') || '0') * 100);
    });
    totalValEl.textContent = money(sum);
  }
  function optionByVeld(veld) {
    for (var i = 0; i < optionChecks.length; i++) if (optionChecks[i].getAttribute('data-veld') === veld) return optionChecks[i];
    return null;
  }
  function setOption(check, on, val) {
    check.checked = on;
    var inp = inputFor(check);
    if (inp) { inp.disabled = !on; inp.hidden = !on; if (on && val != null) inp.value = val; if (!on) inp.value = ''; }
  }
  function autoView(veld) {
    if (views.length < 2) return;
    var i = veld === 'naam' ? viewIdx('naam') : viewIdx('nummer');
    if (i > -1 && i !== curView) showView(i);
  }
  function viewIdx(el) { for (var i = 0; i < views.length; i++) if (views[i].shows.indexOf(el) > -1) return i; return -1; }

  // ---------- Enable / submit ----------
  var hasPriced = optionChecks.some(function (c) { return parseFloat(c.getAttribute('data-prijs') || '0') > 0; });

  function enable(on) {
    if (panel) panel.hidden = !on;
    if (totaalEl) totaalEl.hidden = !(on && hasPriced);
    if (mobBtn) mobBtn.hidden = !on;
    if (on) { openPreview(); } else { if (preview) preview.hidden = true; if (showBtn) showBtn.hidden = true; }
    updateTotal();
  }

  if (toggle) toggle.addEventListener('change', function () { enable(toggle.checked); });

  // ---------- Maatgrens (cfg.min_maat, bijv. 116): bedrukken pas vanaf die maat ----------
  // Leest de maat uit de gekozen variant (optie cfg.maat_optie, standaard "Maat"). Onder de grens:
  // toggle uit + uitgegrijsd, gekozen opties gewist, melding tonen. Niet-numerieke maten blokkeren niet.
  var minMaat = parseInt(cfg.min_maat, 10) || 0;
  var maatOptie = String(cfg.maat_optie || 'Maat').toLowerCase();
  var maatMelding = root.querySelector('[data-fcvd-maatmelding]');
  var toggleLabel = toggle ? toggle.closest('.fcvd-pers__toggle') : null;
  function currentMaat() {
    var names = window.fcvdOptionNames || [], v = window.fcvdSelectedVariant;
    for (var i = 0; i < names.length; i++) {
      if (String(names[i]).toLowerCase() === maatOptie && v && v.options) return v.options[i];
    }
    var r = document.querySelector('input[name="attribute_' + handleOf(maatOptie) + '"]:checked');
    return r ? r.value : null;
  }
  function maatToegestaan() {
    if (!minMaat) return true;
    var n = parseInt(currentMaat(), 10);
    return isNaN(n) || n >= minMaat;
  }
  function resetPersonalisatie() {
    optionChecks.forEach(function (c) { setOption(c, false); });
    if (playerSel) playerSel.value = '';
    if (spelerWrap) spelerWrap.hidden = true;
    if (keuzeWrap) Array.prototype.forEach.call(keuzeWrap.children, function (b) { b.classList.remove('is-active'); });
  }
  function applyMaatgrens() {
    if (!minMaat || !toggle) return;
    var ok = maatToegestaan();
    if (!ok) {
      if (toggle.checked) { toggle.checked = false; enable(false); }
      resetPersonalisatie();
      updateTotal();
    }
    toggle.disabled = !ok;
    if (toggleLabel) toggleLabel.classList.toggle('is-disabled', !ok);
    if (maatMelding) maatMelding.hidden = ok;
  }
  applyMaatgrens();
  document.addEventListener('fcvd:variantchange', applyMaatgrens);

  optionChecks.forEach(function (c) {
    c.addEventListener('change', function () {
      var inp = inputFor(c);
      if (inp) { inp.disabled = !c.checked; inp.hidden = !c.checked; if (!c.checked) inp.value = ''; if (c.checked) { inp.focus(); autoView(c.getAttribute('data-veld')); } }
      if (c.checked && preview && preview.hidden && toggle.checked) openPreview();
      updatePreview(); updateTotal();
    });
  });

  if (inpName) inpName.addEventListener('input', function () {
    if (preview && preview.hidden && toggle.checked) openPreview();
    autoView('naam'); updatePreview();
  });
  if (inpNumber) inpNumber.addEventListener('input', function () {
    var md = parseInt(nrCfg.max || 2, 10);
    var d = (inpNumber.value || '').replace(/[^0-9]/g, ''); if (d.length > md) d = d.slice(0, md);
    if (inpNumber.value !== d) inpNumber.value = d;
    if (preview && preview.hidden && toggle.checked) openPreview();
    autoView('nummer'); updatePreview();
  });

  function setKeuze(mode) {
    if (keuzeWrap) Array.prototype.forEach.call(keuzeWrap.children, function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-keuze') === mode);
    });
    var oN = optionByVeld('naam'), oNr = optionByVeld('nummer');
    if (mode === 'eigen') {
      if (spelerWrap) spelerWrap.hidden = true;
      if (playerSel) playerSel.value = '';
      if (oN) setOption(oN, true, '');
      if (oNr) setOption(oNr, true, '');
      var fi = oN && inputFor(oN); if (fi) fi.focus();
    } else {
      if (spelerWrap) spelerWrap.hidden = false;
      if (oN) setOption(oN, false);
      if (oNr) setOption(oNr, false);
    }
    if (preview && preview.hidden && toggle.checked) openPreview();
    updatePreview(); updateTotal();
  }
  if (keuzeWrap) keuzeWrap.addEventListener('click', function (e) {
    var b = e.target.closest('[data-keuze]'); if (b) setKeuze(b.getAttribute('data-keuze'));
  });

  if (playerSel) playerSel.addEventListener('change', function () {
    var val = playerSel.value; if (!val) return;
    var parts = val.split('|'), nm = parts[0] || '', num = parts[1] || '';
    var oN = optionByVeld('naam'), oNr = optionByVeld('nummer');
    if (oN) setOption(oN, true, nm);
    if (oNr) setOption(oNr, true, num);
    if (preview && preview.hidden && toggle.checked) openPreview();
    updatePreview(); updateTotal();
  });

  if (mobBtn) mobBtn.addEventListener('click', function () {
    openPreview();
    if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  if (showBtn) showBtn.addEventListener('click', openPreview);
  window.addEventListener('resize', fitStage);

  // Onderschep submit: bouw bundel met add-on-regels (zoals fcvd-addons).
  if (form) form.addEventListener('submit', function (ev) {
    if (!toggle || !toggle.checked) return;
    if (!maatToegestaan()) { ev.preventDefault(); applyMaatgrens(); alert('Bedrukken is mogelijk vanaf maat ' + minMaat + '.'); return; }
    var chosen = optionChecks.filter(function (c) { return c.checked; });
    if (!chosen.length) return; // niks gekozen -> gewoon shirt

    // Verplicht: gekozen optie met invoerveld mag niet leeg zijn
    var invalid = null;
    chosen.forEach(function (c) {
      var inp = inputFor(c);
      if (inp && !inp.value.trim()) { inp.classList.add('fcvd-optie__input--error'); if (!invalid) invalid = inp; }
    });
    if (invalid) { ev.preventDefault(); invalid.focus(); alert('Vul de gekozen optie(s) in (naam of rugnummer) voordat je toevoegt.'); return; }

    ev.preventDefault();
    var qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
    var mainId = form.querySelector('[name="id"]').value; if (!mainId) return;
    var bundleId = 'fcvd-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);

    var summary = [], addonItems = [], mainProps = {};
    chosen.forEach(function (c) {
      var variant = parseInt(c.getAttribute('data-variant'), 10);
      var prop = c.getAttribute('data-prop') || c.getAttribute('data-label');
      var label = c.getAttribute('data-label');
      var inp = inputFor(c);
      var val = inp ? inp.value.trim() : '';
      summary.push(val ? (prop + ': ' + val) : label);
      if (variant) {
        var p = { _bundle_id: bundleId }; if (val) p[prop] = val;
        addonItems.push({ id: variant, quantity: qty, properties: p });
      }
      // gratis opties (geen variant, bijv. fanartikelen): alleen in de Personalisatie-samenvatting,
      // niet ook nog als losse property -> voorkomt dubbele regels in de winkelwagen.
    });
    if (addonItems.length) mainProps._bundle_id = bundleId; // alleen bundelen als er add-on-regels zijn (shirts)
    if (summary.length) mainProps['Personalisatie'] = summary.join(' · ');

    var items = [{ id: parseInt(mainId, 10), quantity: qty, properties: mainProps }].concat(addonItems);
    var btn = form.querySelector('.single_add_to_cart_button');
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { alert((res.data && res.data.description) || 'Toevoegen mislukt'); if (btn) { btn.disabled = false; btn.textContent = 'In winkelwagen'; } return; }
        window.location.href = '/cart';
      })
      .catch(function (err) { alert('Fout: ' + err.message); if (btn) { btn.disabled = false; btn.textContent = 'In winkelwagen'; } });
  });
})();
